import React, {Component} from 'react';
import Container from "react-bootstrap/Container";

class Account extends Component {
    render() {
        return (
            <Container className="mt-5">
                {window.location.href="/"}
                <div className="lead">
                    {localStorage.getItem("mau_user_name")}
                </div>
            </Container>
        );
    }
}

export default Account;